import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEntMonedasAction,
  setActivoEntMonedasAction,
} from './EntMonedasAction';
import FormEntMonedas from './components/FormEntMonedas';
import ListadoEntMonedas from './components/ListadoEntMonedas';

const EntMonedasView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {(loginStore.isRoot ||
          loginStore.isAdmin ||
          loginStore.isAdminTeacher) && (
          <BotonComponent
            click={async () => {
              await setActivoEntMonedasAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
            text="Asignar"
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoEntMonedasAction(dispatch, null);
            await allEntMonedasAction(dispatch, entMonedasStore.params);
          }}
          disabled={
            entMonedasStore.all.length === 0 && entMonedasStore.loadingAll
          }
          white
          refreshIcon
          text={entMonedasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEntMonedas
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEntMonedas"
        title={
          entMonedasStore.activo
            ? `Editar ${entMonedasStore.activo.moneda.nombre}`
            : 'Asignar moneda'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntMonedas
          activo={entMonedasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntMonedasView;
